import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Grid, Card, InputLabel, MenuItem, Select, Button, Typography, Box
} from '@mui/material';
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { CustomSelect } from 'admin/components/atoms';
import service from '../../api/services';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { AutoComplete } from '../../components/atoms';
import SoftButton from 'components/SoftButton';
import { DATA_LIMIT } from 'utils/api';
const types = [{ label: 'Thumbs Up', value: 'Thumbs Up' }, { label: 'Thumbs Down', value: 'Thumbs Down' }];
const optionSchema = Yup.object({
    label: Yup.string().required('Label is required'),
    value: Yup.string().required('Value is required'),
}).required('required');
const validationSchema = Yup.object({
    reviewName: Yup.string().required('Review name is required'),
    // type: Yup.string().required('Type is required'),
    type: Yup.array()
        .of(Yup.string().required('Type is required'))
        .min(1, 'At least one type is required')
        .required('Type is Required'),
    category: Yup.array()
        .of(Yup.string().required('Category is required'))
        .min(1, 'At least one category is required')
        .required('Category is Required'),
});

const CreateReviewForm = () => {
    const [categoryData, setCategoryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const params = useParams()
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            reviewName: '',
            type: [],
            category: [],
        },
        validationSchema,
        onSubmit: async (values) => {
            let tempID = values?.category
            try {
                let payload = {
                    category: tempID,
                    name: values?.reviewName,
                    type: values?.type,
                }

                const response = params?.id
                    ? await service.reviewList.edit(params.id, payload)
                    : await service.reviewList.add(payload)
                if (response.status === 200 || response.status === 201) {
                    navigate(-1);
                    toast.success(response?.data?.message);
                } else {
                    toast.error(response?.data.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message);
                console.error('Submission error:', error);
            }
        },
    });

    const getAllCategory = async (value = '') => {
        try {
            setLoading(true)
            const response = await service.categories.view({ limit: DATA_LIMIT, searchData: value });
            if (response?.data?.data) {
                setCategoryData(
                    response.data.data.map((item) => ({
                        ...item,
                        label: item.name,
                        value: item._id,
                    }))
                );
                setLoading(false)
            }

        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
    };

    const getDetailById = async (data) => {
        try {
            const res = await service.reviewList.getDetailById(params.id);
            const responseData = res?.data?.data;

            if (!responseData) {
                console.warn("No data found in response.");
                return;
            }

            // const matchedCategory = data?.find(
            //     item => item?._id === 
            // );
            let matchedCategory = responseData?.category?.map((item) => item._id)
            // let matchedType = responseData?.type?.map((item) => item._id)
            console.log("Matched Category:", matchedCategory);

            formik.setValues({
                reviewName: responseData.name || '',
                type: responseData?.type || '',
                category: matchedCategory || null,
            });
        } catch (error) {
            console.error("Failed to fetch review detail:", error);
        }
    };
  useEffect(() => {
        getAllCategory()
        if (params?.id) {
            getDetailById()
        }
    }, [])


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox mt={3}>
                <Card className="glassmorphism-card"
                    sx={{
                        // minHeight: '470px',
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "center",
                        // alignItems: "center",
                        padding: 2,
                        boxShadow: 2,
                        overflow: 'visible',
                        position: 'relative',
                    }}>
                    <SoftTypography variant="h5" fontWeight="bold" mb={2}>{`${params.id ? 'Edit' : 'Create'}`} Reviews</SoftTypography>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Enter Review<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <SoftInput
                                    name="reviewName"
                                    placeholder="Enter Review"
                                    value={formik.values.reviewName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.reviewName && Boolean(formik.errors.reviewName)}
                                />
                                {formik.touched.reviewName && formik.errors.reviewName && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.reviewName}
                                    </SoftTypography>
                                )}
                            </Grid>



                            <Grid item xs={6}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Select Type<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <AutoComplete
                                    fullWidth
                                    name="type"
                                    options={types}
                                    value={types.filter(option => formik.values.type.includes(option.value))}
                                    onChange={(e, value) => {
                                        const values = value.map(v => v.value); // only store values
                                        formik.setFieldValue('type', values);
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.type && Boolean(formik.errors.type)}
                                    invalid={formik.touched.category && Boolean(formik.errors.category)}
                                    multiple={true}
                                // displayEmpty
                                />
                                {formik.touched.type && formik.errors.type && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.type}
                                    </SoftTypography>
                                )}
                            </Grid>
                            <Grid item xs={6}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Select Category<span style={{ color: 'red' }}>*</span></SoftTypography>

                                <AutoComplete
                                    fullWidth
                                    name="category"
                                    options={categoryData}
                                        loading={loading}
                                    placeholder={"Search Category..."}
                                    value={categoryData.filter(option => formik.values.category.includes(option.value))}
                                    onChange={(e, value) => {
                                        const values = value.map(v => v.value); // only store values
                                        formik.setFieldValue('category', values);
                                    }}
                                    onBlur={() => formik.setFieldTouched('category', true)}
                                    onInputChange={(value) => {
                                        getAllCategory(value);  
                                    }}
                                    error={formik.touched.category && Boolean(formik.errors.category)}
                                    invalid={formik.touched.category && Boolean(formik.errors.category)}
                                    multiple={true}
                                />

                                {formik.touched.category && formik.errors.category && (
                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                        {formik.errors.category}
                                    </SoftTypography>
                                )}
                            </Grid>
                            <Grid item xs={6} display="flex" gap={2}>
                                <SoftButton type="submit" variant="gradient" color="info">Submit</SoftButton>
                                {/* <Button variant="outlined" onClick={()=> navigate(-1)}>Cancel</Button> */}
                                <SoftButton
                                    variant="outlined"
                                    color="info"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </SoftButton>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </SoftBox>
        </DashboardLayout>
    );
};

export default CreateReviewForm;
